﻿import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import ClaimDetails from "./ClaimDetails.svelte";
import DocumentUpload from "./DocumentUpload.svelte";


const confirmationPages = [
    {
        component: LandingPage,
        routeId: "/Registration",
        confirmationHeading: null,
    },
    {
        component: PersonalDetails,
        routeId: "/Registration/PersonalDetails",
        confirmationHeading: "Your details",
    },
    {
        component: ClaimDetails,
        routeId: "/Registration/ClaimDetails",
        confirmationHeading: "Claim details",
    },
];

export default confirmationPages;


2.5